export default "__VITE_ASSET__QYMOmm0i__"